<template>
  <div>
    <div class="col float-right">
      <q-btn-group outline>
        <q-btn v-if="editable && !checkEnvKind" class="custom-btn" label="QR 코드" icon="qr_code_scanner" color="black" size="md">
          <q-popup-proxy>
            <c-card title="QR 코드 출력" class="cardClassDetailForm">
              <template slot="card-button">
                <c-btn label="인쇄" icon="print" @btnClicked="print" />
              </template>
              <template slot="card-detail">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="wrap" action="#" id="printJS-form">
                      <vue-qrcode
                        :value="serverName+'/sop/edu/result/educationResult?eduEducationId='
                        + param.eduEducationId" 
                        :options="{ width: 200 }"
                        class="canvas"
                      >
                      </vue-qrcode>
                      <span class="facilityStyle">
                        <p class="abc" >
                          <b>{{'-교육명 : '}}</b>{{tabParam.educationName}}
                          <br>
                          <b>{{'-교육일시 : '}} </b>{{tabParam.educationDate}}
                          <br>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </c-card>
          </q-popup-proxy>
        </q-btn>
        <c-btn v-show="editable&&disabled" :showLoading="false" label="완료취소" icon="remove"  @btnClicked="resultCancel" />
        <c-btn v-show="editable&&!disabled" :showLoading="false" label="완료" icon="check"  @btnClicked="resultComplete" />
        <c-btn v-show="editable&&disabled" label="대상자 연명부" icon="print" @btnClicked="btnResultUsers" />
      </q-btn-group>
    </div>
    <c-tab
      type="vertical"
      :height.sync="tabHeight"
      :tabItems="tabItems"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param.sync="param"
          :tabParam="tabParam"
          @transInfo="transInfo"
          @getFiles="getFiles"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import printJs from 'print-js'
import selectConfig from '@/js/selectConfig';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'education-result-tab',
  components: {
    VueQrcode
  },
  props: {
    param: {
      type: Object,
      default: () => ({
        eduEducationId: '',
        completeSt: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      tabParam: {
        eduEducationId: '',
        educationName: '',
        eduCourseId: '',
        plantCd: '',
        educationYear: '',
        educationCourseName: '',
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: '',
        legalEducationFlag: null,
        educationTime: '',
        educationCycle: null,
        educationPurpose: '',
        relationLaws: '',
        mainTargetAudience: '',
        educationMonth: null,
        educationLocation: '',
        estimatedEducationExpenses: '',
        executionBudget: '',
        educationStartDate: '',
        educationEndDate: '',
        educationStartTime: '',
        educationEndTime: '',
        instructorInformation: '',
        sopMocId: '',
        educationMethodCd: null,
        educationOverview: '',
        evaluationEvalCd: '',
        documentStatusCd: '',
        sumEducationTime: '',
        qrCodeRoute: '',

        regUserId: '',
        chgUserId: '',
        eduSubjectList: [], // 과정별 교육과목
        eduAttendeeList: [],
      },
      completeUrl: '',
      cancelUrl: '',
      completeFileUrl: '',
      editable: true,
      splitter: 5,
      tab: 'educationResultInfo',
      serverName: '',
      printUrl: '',
      fileList: [],
    };
  },
  computed: {
    tabHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      numHeight = numHeight - 40
      return numHeight + 'px';
    },
    disabled() {
      return this.tabParam.documentStatusCd === 'ESC000010'
    },
    tabItems() {
      return [
        { name: 'educationResultInfo', icon: 'edit', label: '기본정보', component: () => import(`${'./educationResultInfo.vue'}`) },
        { name: 'educationComplete', icon: 'how_to_reg', label: '교육이수', component: () => import(`${'./educationComplete.vue'}`) },
        // { name: 'educationTextBook', icon: 'checklist', label: '교육교재', component: () => import(`${'./educationTextBook.vue'}`) },
      ]
    },
    checkEnvKind() {
      return this.tabParam.educationKindCdLarge === 'EKFC000002'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      this.redirectUrl = selectConfig.mdm.equipment.qrUrl.url;
      this.completeFileUrl = selectConfig.sop.edu.result.certificate.url;
      this.completeUrl = transactionConfig.sop.edu.result.complete.url;
      this.cancelUrl = transactionConfig.sop.edu.result.cancel.url;
      this.printUrl = selectConfig.sop.edu.result.print.second.url;
      // list setting
      this.serverUrl();
      this.getFiles();
    },
    serverUrl() {
      this.$http.url = this.redirectUrl;
      this.$http.type = 'GET';
      this.$http.param = {};
      this.$http.request(
        _result => {
          this.serverName = _result.data
        },
        _error => {
          window.getApp.$emit('APP_REQUEST_ERROR', _error);
        }
      );
    },
    print() {
      printJs({
        printable: 'printJS-form',
        type: 'html',
        font_size: '20px',
        targetStyles: ['*'],
      })
    },
    transInfo(data) {
      this.tabParam = data;
    },
    resultComplete() {
      let flag = false;
      // if (this.tabParam.educationKindCdLarge === 'EKFC000002') {
      //   console.log(this.fileList)
      //   let str = '';
      //   let count = 0;
      //   this.$_.forEach(this.fileList, _item => {
      //     if (!_item) {
      //       str += this.tabParam.eduAttendeeList[count].attendeesName + ', '
      //     } 
      //     count ++;
      //   })
      //   if (str) {
      //     window.getApp.$emit('ALERT', {
      //       title: '안내', // 안내
      //       message: '이수증 업로드를 안 한 교육대상자가 있습니다.[' + str.substring(0, str.length-2) + ']',
      //       type: 'warning', // success / info / warning / error
      //     });
      //     flag = true; 
      //   } 
      // }
      if (!flag) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '결과완료하시겠습니까?(저장과 함께 처리됩니다.)',
          // TODO : 점검완료 하시겠습니까?
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.tabParam.documentStatusCd = 'ESC000010'
            this.$http.url = this.completeUrl;
            this.$http.type = 'PUT';
            this.$http.param = this.tabParam;
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              if (this.tabParam.documentStatusCd) {
              this.$emit('emitStep', {
                name: 'currentStatus',
                param: this.tabParam.documentStatusCd 
              })
            }
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
      });
      }
    },
    resultCancel() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '계획완료 상태로 돌아갑니다. 결과완료를 취소하시겠습니까?',
        // TODO : 점검완료 하시겠습니까?
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.tabParam.documentStatusCd = 'ESC000005'
          this.$http.url = this.cancelUrl;
          this.$http.type = 'PUT';
          this.$http.param = {
            eduEducationId: this.param.eduEducationId,
            documentStatusCd: 'ESC000005',
            chgUserId: this.$store.getters.user.userId,
          };
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            if (this.tabParam.documentStatusCd) {
              this.$emit('emitStep', {
                name: 'currentStatus',
                param: this.tabParam.documentStatusCd 
              })
            }
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    btnResultUsers() {
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        eduEducationId: this.param.eduEducationId
      }
      this.$http.request(
        _result => {
          let fileOrgNm = this.tabParam.educationName + ' 연명부.docx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    },
    // 이수증 파일 들고오기 (valid check)
    getFiles() {
      if (this.param.eduEducationId) {
        this.$http.url = this.$format(this.completeFileUrl, this.param.eduEducationId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.fileList = _result.data;
          this.updateMode = true;
        },);
      }
    },
  }
};
</script>
